import { render, staticRenderFns } from "./tracker.vue?vue&type=template&id=2bcc3e4a&"
import script from "./tracker.vue?vue&type=script&lang=ts&"
export * from "./tracker.vue?vue&type=script&lang=ts&"
import style0 from "./tracker.vue?vue&type=style&index=0&id=2bcc3e4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports